var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-tabs",
        { attrs: { "content-class": "pt-1" } },
        [
          _c("b-tab", { attrs: { title: "Segments" } }, [_c("Segment")], 1),
          _c("b-tab", { attrs: { title: "SMTP Settings" } }, [_c("Smpt")], 1),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }